<template>
    <div name="outlink-popup" class="container">
        <div class="contents">
            <div class="header">
                <img @click="close" class="close-icon" src="../../assets/close_icn.png" />
            </div>
            <iframe :src="link" 
                width="100%"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'outlinkPopup',
    props: ['link'],
    methods: {
        close: function()
        {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
    .container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .contents {
        position: fixed;
        background: #FFF;
        max-width: 600px;
        width: 100%;
        height: calc(100vh);
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }
    iframe {
        border: none;
        height: calc(100% - 46px);
    }
    .header {
        height: 46px;
        width: 100%;
        background: #FFF;
        padding-right: 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .close-icon {
        width: 22px;
        cursor: pointer;

    }
</style>


// WEBPACK FOOTER //
// src/components/modals/OutLinkPopup.vue